import { render, staticRenderFns } from "./StarsCombinations.vue?vue&type=template&id=0e5f2be4&scoped=true&lang=pug"
import script from "./StarsCombinations.vue?vue&type=script&lang=js"
export * from "./StarsCombinations.vue?vue&type=script&lang=js"
import style0 from "./StarsCombinations.vue?vue&type=style&index=0&id=0e5f2be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5f2be4",
  null
  
)

export default component.exports